<script lang="ts">
  import { setContext } from 'svelte'
  import { writable } from 'svelte/store'
  import { fade, slide } from 'svelte/transition'
  
  import DepartmentMenu from './MobileDepartmentMenu.svelte'
  import MobileSearch from './MobileSearch.svelte'
  import MobileMenuNav from './MobileMenuNav.svelte'
  import ChevronLeft from './ChevronLeft.svelte'
  import ChevronDown from './ChevronDown.svelte'

  import type { Writable } from 'svelte/store'

  export let menu = []
  export let pathChunks: string[]
  export let currentDepartment: object|undefined = undefined
  export let currentDepartmentMenu: object[]|undefined = undefined
  export let departmentHomeItem
  // export let mainMenuError: Writable<boolean>|undefined = undefined
  export let deptMenuError: Writable<boolean>|undefined = undefined

  const menuNavHistory: Writable<{key: string, items: any[]}[]> = writable([{
    key: '/',
    items: menu
  }])
  const backItemTitle = writable('Main Menu')
  const backItemIconString = writable('fa-solid:chevron-up')
  const isPolarityReversed = writable(false)
  const depthStore: Writable<number> = writable(0)
  $: depthStore.set($menuNavHistory.length - 1)

  setContext('menuNavHistory', menuNavHistory)
  setContext('backItemTitle', backItemTitle)
  setContext('backItemIconString', backItemIconString)
  setContext('isPolarityReversed', isPolarityReversed)
  setContext('menuAnimationDuration', 400) // this isn't going to change throughout the app's execution, so we don't need it to be reactive, and thus it doesn't need to be a store

  $: last = $menuNavHistory[$menuNavHistory.length - 1]
  $: menuStateClass = `menu-state${last.key.replaceAll('/', '--')}${$menuNavHistory.length === 1 ? 'root' : ''}`

  const handleBackClick = (e)=> {
    if($menuNavHistory.length > 1) {
      isPolarityReversed.set(true)
      setTimeout(()=>isPolarityReversed.set(false), 400)

      const popped = $menuNavHistory.pop()
      const itemToGoBackTo = $menuNavHistory[$menuNavHistory.length - 1]

      if($menuNavHistory.length === 1) {
        backItemTitle.set('Main Menu')
      } else {
        backItemTitle.set(itemToGoBackTo.previousTitle)
      }
      
      menuNavHistory.set($menuNavHistory)
    }
  }

  const animationSpeed = 300
  let showSearch = false
</script>
<div class="mobile-menu-modal" style:height={window.innerHeight - (90 + 140) + 'px'}>
  <div class="search-wrapper ucBlack-bg" transition:fade>
    <MobileSearch />
  </div>
  <nav class="mobile-menu relative" transition:fade>
    <button class="back-item" on:click={handleBackClick} class:is-main-menu={$menuNavHistory.length === 1}>
      <p class="grow">
        <img src="/font-awesome/svgs/duotone/house-duotone-white.svg" alt="Home Icon" class="mobile-nav-icon house-icon" />
        <ChevronLeft />
        {$backItemTitle}
      </p>
      <!-- <img src="/font-awesome/svgs/solid/chevron-down-white.svg" alt="Arrow pointing down" class="mobile-nav-icon"> -->
      <ChevronDown white />
    </button>

    <div class="nav-wrapper">
      {#each $menuNavHistory as _}
        <MobileMenuNav
          class="{menuStateClass}"
          show={last.key === _.key}
          menu={last.hasOwnProperty('key') && last.key === _.key  ? _.items : menu}
          {pathChunks}
          {depthStore}
        />
      {/each}
      {#if currentDepartmentMenu && !$deptMenuError}
      
        <DepartmentMenu {currentDepartment} {currentDepartmentMenu} {departmentHomeItem} />
      {/if}
    </div>
  </nav>
</div>

<style lang="scss">
  .search-wrapper {
    --search-height: 140px;
    position: relative;
    height: var(--search-height);
    display: grid;
    align-items: center;
    opacity: 0.95;

  }
 .nav-wrapper {

 }
</style>